"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["OLD_VEHICLE"] = 20016] = "OLD_VEHICLE";
    ErrorCodes[ErrorCodes["NO_VALUATION"] = 6] = "NO_VALUATION";
    ErrorCodes[ErrorCodes["VEHICLE_MISSING_FROM_VALUATION"] = 2015] = "VEHICLE_MISSING_FROM_VALUATION";
    ErrorCodes[ErrorCodes["VEHICLE_NOT_FOUND"] = 1002] = "VEHICLE_NOT_FOUND";
    ErrorCodes[ErrorCodes["TOO_MANY_VALUATIONS"] = 20020] = "TOO_MANY_VALUATIONS";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
